<template>
  <div>
    <navHeader></navHeader>
    <div class="page_con">
      <sideBar></sideBar>
      <div class="person_list pr20">
        <div class="clearfix pl20 add_top_box mb30">
          <ul class="top_tab fl">
            <li class="fl" :class="{active:show=='info'&&$route.params.type =='retire'}" @click="tabToEdit">个人信息</li>
            <li class="fl" :class="{active:show=='pension'}"
                v-show="$route.params.status=='see'&&$route.params.type=='retire'" @click="tabToPension">养老金计算</li>
          </ul>
        </div>
        <workerInfo v-if="show == 'info'" class="pl20"></workerInfo>
        <pensionTable v-show="$route.params.status=='see'" v-if="show == 'pension'" class="pl20"></pensionTable>
      </div>
    </div>
  </div>
</template>
<script>
  import navHeader from '../components/header'
  import sideBar from '../components/siderBar'
  import workerInfo from '../components/workerInfo'
  import pensionTable from '../components/pension_table'
  export default {
    name : 'addPerson',
    data () {
      return {
        show:'info',
      }
    },
    components:{
      'navHeader' : navHeader,
      'sideBar' : sideBar,
      'workerInfo' : workerInfo,
      'pensionTable' : pensionTable
    },
    methods:{
      tabToEdit:function () {
        this.show = 'info';
      },
      tabToPension:function () {
        this.show = 'pension';
      }
    }
  }
</script>
<style lang="less" scoped>
  .add_top_box{
    border-bottom: 1px solid #b9bac2;
  }
  .page_con{
    display: flex;
  }
  .person_list{
    position: relative;
    margin-left: 240px;
    flex:1;
    ul{
      li{
        height:50px;
        line-height: 50px;
        cursor: pointer;
      }
    }
  }
  .top_tab{
    li{
      padding:0 10px;
      text-align: center;
      font-size: 18px;
      margin-right: 10px;
    }
    li:hover{
      color: #00A5FA;
    }
    li.active{
      color: #00A5FA;
      border-bottom: 2px solid #00A5FA;
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/add.vue